import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import queryKeys from '@/constants/queryKeys';
import { TPeerSupportContactEventCreation } from '@/types/PeerSupport.types';
import { createContactEventPost } from '@/services/api/requests/peer-support';

const useCreateContactEvent = (onSuccessCallback?: () => void) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: async (eventInfo: TPeerSupportContactEventCreation) => {
      const response = await createContactEventPost(eventInfo);

      return response;
    },
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: [queryKeys.peerSupport.dashboard] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.peerSupport.engagement] });

      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Contact logged successfully!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Error while logging contact',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default useCreateContactEvent;
